<template>
  <CRow alignHorizontal="center" alignVertical="strech" :gutters="true">
    <CCol class="pr-2">
      <div class="card-home-board card-superblock">
        <div v-if="loadingAudienceEvolution" class="d-flex justify-content-center align-items-center mb-3 bg-white" style="height: 280px">
          <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
        </div>
        <AudienceBlock :audienceEvolution="audienceEvolution" v-else />
      </div>
    </CCol>
    <CCol class="pl-2 pr-2">
      <div class="card-home-board card-superblock">
        <div class="d-flex flex-column justify-content-center">
          <div class="d-flex justify-content-between mb-5 p-4 card-home-header">
            <h4 class="font-weight-normal mb-2 pt-1">
              {{ $t('home.blockSegments.segment') }}
            </h4>
            <CButton class="px-4 py-2 font-weight-bold ctaInfoUserPrimary" @click="$router.push({ name: 'segment-create' })">
              {{ $t('home.blockSegments.create-segment') }}
            </CButton>
            <!-- <router-link :to="{ name: 'segment-create' }" class="ctaInfoUserPrimary">
            
          </router-link> -->
          </div>
          <div class="d-flex flex-column justify-content-center text-center p-5">
            <div class="text-center"><img src="/img/create-segment.svg" class="" style="max-width: 250px" /></div>
            <h4 class="font-weight">{{ $t('home.blockSegments.title') }}</h4>
            <p class="text-gray-600 my-4">
              {{ $t('home.blockSegments.description') }}
            </p>
          </div>
        </div>
      </div>
    </CCol>
    <CCol class="pl-2">
      <div class="card-home-board card-superblock">
        <div v-if="loadingSmartinsights" class="d-flex justify-content-center align-items-center mb-3 bg-white" style="height: 280px">
          <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
        </div>
        <div v-else class="d-flex flex-column justify-content-center">
          <div class="d-flex justify-content-between mb-5 p-4 card-home-header">
            <h4 class="font-weight-normal mb-4 pt-1">
              {{ $t(`general.smartinsights.title`) }}
            </h4>
          </div>
          <div class="d-flex flex-column justify-content-center text-center p-5">
            <div class="text-center"><img src="/img/smart.svg" class="" style="max-width: 200px" /></div>
            <h4 class="font-weight">{{ $t(`general.${smartInsights.title}`) }}</h4>
            <p class="text-gray-600 my-4">
              {{ $t(`general.${smartInsights.description}`) }}
            </p>
          </div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
import AudienceBlock from './AudienceBlock/Index'

export default {
  name: 'supportBlocks',
  components: { AudienceBlock },
  data() {
    return {
      smartInsights: {
        title: '',
        subtitle: '',
        description: '',
        icon: '',
      },
      audienceEvolution: {},
      loadingAudienceEvolution: false,
      organizationId: null,
      webAreaId: 1,
      loadingSmartinsights: true,
    }
  },
  mounted() {
    this.organizationId = this.$route.params.organizationId
    this.getSmartInsight()
    this.getAudienceEvolution()
  },
  methods: {
    getSmartInsight() {
      services
        .getSmartInsight(this.organizationId, this.webAreaId)
        .then((res) => {
          this.smartInsights.title = res.data.data.smartInsight.title
          this.smartInsights.subtitle = res.data.data.smartInsight.subtitle
          this.smartInsights.description = res.data.data.smartInsight.description
          //this.smartInsights.icon = res.data.data.smartInsight.icon
        })
        .finally(() => {
          this.loadingSmartinsights = false
        })
    },
    getAudienceEvolution() {
      this.loadingAudienceEvolution = true

      services
        .getAudienceEvolution(this.organizationId)
        .then((res) => {
          this.audienceEvolution = res.data.data
        })
        .finally(() => {
          this.loadingAudienceEvolution = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-superblock {
  height: 100%;
}

.wrapperBlock_suport > div {
  align-items: center;
}
.support {
  &__box {
    border-radius: 2px;
    min-height: 380px;
    height: 100%;
    padding: 2rem 4rem 3rem;

    &--primary {
      background: lighten($primary, 37%);
    }
  }

  &__totalCotacts {
    font-size: 3.1rem;
  }
}

.line-height-1-5 {
  line-height: 1.5;
}

.card-home-header {
  border-bottom: 1px solid #f1f3f5;
}

.card-home-audience-numbers {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  min-width: 45%;
  height: 230px;
  padding: 20px;
}

.card-home-audience-total {
  color: #343a40;
  font-size: 36px;
  font-weight: 700;
  margin-top: 40px;
}

.card-home-audience-subtitle {
  color: #868e96;
  font-size: 15px;
}

.card-home-audience-icon {
  color: #e8e0f0;
}
</style>
